const ENV = process.env.NODE_ENV !== "production" ? process.env : window._env_;
export default ENV;
